import React from "react"
import { EditorState } from "draft-js"
import styled from "styled-components"
import { FontWeightButton } from "./font-weight-button"
import { FontSizeSelect } from "./font-size-select"
import { FontColorButton } from "./font-color-button"

export interface IToolBarProps {
  onChange: (editorState: EditorState) => void
  editorState: EditorState
}

interface IProps extends IToolBarProps {
  className?: string
}

// For Message
export const FullToolBar = (props: IProps) => {
  return (
    <Wrapper className={props.className}>
      <FontSizeSelect {...props} />
      <FontWeightButton {...props} />
      <FontColorButton {...props} />
    </Wrapper>
  )
}

// For Annotation
export const ToolBarWithoutWeight = (props: IProps) => {
  return (
    <Wrapper className={props.className}>
      <FontSizeSelect {...props} />
      <FontColorButton {...props} />
    </Wrapper>
  )
}

// For Introduction
export const ToolBarWithoutSize = (props: IProps) => {
  return (
    <Wrapper className={props.className}>
      <FontWeightButton {...props} />
      <FontColorButton {...props} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  > * {
    margin-right: 12px;
  }
`
